import React from 'react';
import classNames from 'classnames';

import {SCHEDULE_ITEM_TYPES} from 'ducks/tenancy';

import {formatDate} from 'utils/datetime';

import Alert from 'components/Alert';
import Table from 'components/Table';
import Money from 'components/Money';
import Ellipsis from 'components/Ellipsis';
import PaymentStatusTag from 'components/PaymentStatusTag';

import {getSyncedWithXeroIcon} from 'containers/BookingDetail/utils';

const PaymentRow = ({payment, handleRowClick, scheduleType}) => {
  const {paymentDetails} = payment;

  const paymentDescription = paymentDetails.batchNumber
    ? `Batch Number: ${paymentDetails.batchNumber} - ${
        paymentDetails.reference
      }`
    : paymentDetails.reference;

  return (
    <Table.Row
      className={classNames('scheduleRow', {
        highlighted: payment.highlighted
      })}
      onClick={() =>
        handleRowClick(SCHEDULE_ITEM_TYPES.PAYMENT, payment.id, scheduleType)
      }>
      <Table.Cell>{formatDate(payment.date)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="activity">
        <div className="colab-centered">
          {paymentDetails.hasXeroErrors && <Alert />}
          <Ellipsis>{payment.activity}</Ellipsis>
        </div>
      </Table.Cell>
      <Table.Cell className="details">
        <Ellipsis>{paymentDescription}</Ellipsis>
      </Table.Cell>
      <Table.Cell>
        <PaymentStatusTag status={paymentDetails.status} />
      </Table.Cell>
      <Table.Cell>{getSyncedWithXeroIcon(paymentDetails.xeroId)}</Table.Cell>
      <Table.Cell />
      <Table.Cell className="payment">
        <Money
          amount={payment.amount}
          balance
          className={classNames({
            strikeThrough: paymentDetails.voided
          })}
        />
      </Table.Cell>
      <Table.Cell className="balance">
        <Money amount={payment.balance} balance />
      </Table.Cell>
    </Table.Row>
  );
};

export default PaymentRow;
